// Brand story — owner-supplied 2026-07-11. Craftsmanship photo is a CC BY stock
// image (AboutPage.jsx) until the owner has shop photos.

// Rewritten 2026-10-25 in plainer words (owner: the first version read as
// AI-written). Facts unchanged from the owner's 2026-07-11 text.
export const ABOUT = {
  title: "Our Story",
  lede: "Bindal's Creation is a family-run ethnic wear shop in Ghaziabad. We've been selling sarees, lehengas, suits and more since 2018.",
  story: [
    "When we opened in 2018, we wanted every garment in the shop to be one we had chosen ourselves. That hasn't changed. We pick each piece by hand instead of ordering in bulk from a catalogue.",
    "We're proud of our collection and of the people who shop with us. If you're looking for something particular, tell us. Often we can find it for you.",
  ],
  craftsmanship: {
    title: "Picked by hand",
    body: [
      "Before anything goes on our shelves, we look closely at the fabric, the work and the finish. Have an occasion, a colour or a kind of embroidery in mind? Ask us, and we'll help you find the right piece or source it for you.",
    ],
  },
  values: [
    { title: "Chosen by us", desc: "Picked by our family for fabric, finish and value." },
    { title: "Visit the shop", desc: "Come and see us at Sihani Gate Market, Ghaziabad." },
    { title: "Ask us first", desc: "Questions before you buy? Message us on WhatsApp." },
  ],
};
